const SvgCloud1 = (props) => (
  <>
    <path d="M360 288V96L192 0 24 96v192l168 96 168-96z" fill={props.p10} />
  </>
);

export default SvgCloud1;
